/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationChannelListEntry
 */
export interface NotificationChannelListEntry {
    /**
     * 
     * @type {string}
     * @memberof NotificationChannelListEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationChannelListEntry
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationChannelListEntry
     */
    value: boolean;
}

/**
 * Check if a given object implements the NotificationChannelListEntry interface.
 */
export function instanceOfNotificationChannelListEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function NotificationChannelListEntryFromJSON(json: any): NotificationChannelListEntry {
    return NotificationChannelListEntryFromJSONTyped(json, false);
}

export function NotificationChannelListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationChannelListEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'value': json['value'],
    };
}

export function NotificationChannelListEntryToJSON(value?: NotificationChannelListEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'value': value.value,
    };
}

